import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { Label } from 'synfrastructure';
import GooglePlaces from '@synapsestudios/google-places-field';

class ReduxFormsPlacesAutocomplete extends Component {
  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  };

  static defaultProps = {
    className: null,
    disabled: false,
    label: null,
  };

  onChange = selection => {
    if (!selection || !selection.data || !selection.data.label) {
      return this.props.input.onChange(null);
    }

    const shortLocationComponents = {};

    selection.data.gmaps.address_components.forEach(addressPart => {
      if (addressPart.types.indexOf('locality') !== -1) {
        shortLocationComponents.locality = addressPart.long_name;
      }
      if (addressPart.types.indexOf('administrative_area_level_1') !== -1) {
        shortLocationComponents.administrative_area_level_1 = addressPart.short_name;
      }
      if (addressPart.types.indexOf('country') !== -1) {
        shortLocationComponents.country = addressPart.short_name;
      }
    });

    let shortLocationString = '';

    if (shortLocationComponents.locality) {
      shortLocationString = `${shortLocationComponents.locality}, `;
    }

    if (shortLocationComponents.administrative_area_level_1) {
      shortLocationString = `${shortLocationString}${shortLocationComponents.administrative_area_level_1}, `;
    }

    if (shortLocationComponents.country) {
      shortLocationString = `${shortLocationString}${shortLocationComponents.country}`;
    }

    this.props.input.onChange({
      location_long: selection.data.label,
      location_short: shortLocationString,
      latitude: selection.latitude,
      longitude: selection.longitude,
    });
  };

  render() {
    const { label, className, disabled, initialValue, input, meta: { touched, error } } = this.props;
    const scaffoldClasses = {
      'input-scaffold': true,
      [className]: className,
    };

    const labelClasses = {
      input: true,
      'input--disabled': disabled,
    };

    return (
      <div className={classNames(scaffoldClasses)}>
        <Label className={classNames(labelClasses)}>
          {label ? <span className="input-label">{label}</span> : null}
          <GooglePlaces
            initialValue={initialValue}
            onChange={() => {
              input.onChange(null);
            }}
            onSelect={this.onChange}
            autoActivateFirstSuggest
          />
        </Label>
        {touched && error ? <div className="input-validation">{error}</div> : null}
      </div>
    );
  }
}

export default ReduxFormsPlacesAutocomplete;



// WEBPACK FOOTER //
// ./src/common/forms/ReduxFormsPlacesAutocomplete.js